import { render } from "./InvoicePayments.vue?vue&type=template&id=92bde698&scoped=true"
import script from "./InvoicePayments.vue?vue&type=script&lang=js"
export * from "./InvoicePayments.vue?vue&type=script&lang=js"

import "./InvoicePayments.vue?vue&type=style&index=0&id=92bde698&scoped=true&lang=scss"

import exportComponent from "/srv/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92bde698"]])

export default __exports__